import marker from "../../../images/Markers.png";
import InputMask from "react-input-mask";
import { useEffect, useState } from "react";
import { cpf as cpfValidad } from "cpf-cnpj-validator";
import api from "../../../services/api";

import { Stack, Typography, Box, TextField } from "@mui/material";

import { AccountCircleOutlined } from "@mui/icons-material";

import { formatDate } from "../../../utils/formatarData";
import preencherDadosIdentificacao from "./preencherDadosIdentificacao";
import { dadosIniciais } from "../dadosIniciais";
import ModalDialogs from "../../../components/ModalDialogs";

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "24px",
  },
  label: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: 600,
    color: "rgba(6, 63, 94, 1)",
    fontSize: "16px",
  },
  typography: {
    fontFamily: "Noto Sans",
    fontSize: "16px !important",
    fontWeight: "300 !important",
    lineHeight: "28px !important",
    letterSpacing: "0em !important",
    textAlign: "left !important",
  },
};

export default function VerificaoStep(props) {
  const { nextStep, setDadosPaciente, dadosPaciente } = props;

  const [detalhesPaciente, setDetalhesPaciente] = useState({});
  const [cpfError, setCpfError] = useState("");

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const handleChange = async (event) => {
    const inputCpf = event.target.value;

    setDadosPaciente((prevState) => ({
      ...prevState,
      cpf: inputCpf,
    }));

    if (inputCpf.length <= 13) {
      setCpfError("");
      return;
    }

    if (cpfValidad.isValid(inputCpf)) {
      setLoading(true);
      try {
        const numeroCpf = inputCpf.replace(/\D/g, "");
        const data = await api.post("/cpfexiste/", {
          cpf: numeroCpf,
        });

        if (data.data.paciente) {
          const id = data.data.paciente.id;
          setDetalhesPaciente(data.data);
          setDadosPaciente((prevState) => ({
            ...prevState,
            cpf: data.data.paciente.cpf,
            cns: data.data.paciente.cns,
          }));

          const response = await api.get(`/dadospaciente/${id}`);
          setOpen(true);

          preencherDadosIdentificacao(response.data, setDadosPaciente);
        } else {
        }
      } catch (error) {
        console.error(error.message);
      }

      setLoading(false);
    } else {
      setCpfError("CPF inválido");
    }
  };

  const handleCancelar = () => {
    setDadosPaciente(dadosIniciais);
    setOpen(false);
  };

  const handleContinuar = () => {
    nextStep();
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          gap: "24px",
        }}
      >
        <Stack width={"100%"}>
          <Typography sx={styles.label}>
            CPF <img src={marker} alt="maker" />
          </Typography>

          <InputMask
            mask="999.999.999-99"
            maskChar=""
            value={dadosPaciente.cpf}
            onChange={handleChange}
          >
            {(inputProps) => (
              <TextField
                id={"cpf"}
                {...inputProps}
                error={Boolean(cpfError)}
                helperText={cpfError}
                placeholder={"Informar cpf"}
                sx={styles.typography}
                autoComplete="off"
                required
              />
            )}
          </InputMask>
        </Stack>
        <Stack width={"100%"}>
          <Typography sx={styles.label}>
            CNS <img src={marker} alt="maker" />
          </Typography>
          <InputMask
            mask="999 9999 9999 9999"
            maskChar=""
            value={dadosPaciente.cns}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                cns: event.target.value,
              }));
            }}
          >
            {(inputProps) => (
              <TextField
                {...inputProps}
                id={"cns"}
                placeholder="Informar CNS"
                fullWidth
                required
              />
            )}
          </InputMask>
        </Stack>
      </Box>

      <ModalDialogs
        open={open}
        onClose={() => handleCancelar()}
        title="Você já possui cadastro"
        onActionPrimary={() => handleContinuar()}
        onActionSecondary={() => handleCancelar()}
        primaryButtonText="Continuar cadastro"
        secondaryButtonText="Cancelar"
        modalType="default-not"
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            <Stack>
              <Typography
                fontSize={20}
                fontWeight={"500"}
                lineHeight={"25px"}
                mb={2}
              >
                Esse cpf/cns já foi cadastrado
              </Typography>
              <Stack
                flexDirection={"row"}
                alignContent={"center"}
                justifyContent={"center"}
                mb={1}
                gap={2}
              >
                <AccountCircleOutlined
                  fontSize="24px"
                  sx={{
                    width: "24px",
                    height: "24px",
                    color: "#737373",
                  }}
                />
                <Typography
                  fontSize={18}
                  fontWeight={600}
                  height={"25px"}
                  color="#737373"
                >
                  {detalhesPaciente?.paciente?.nome}
                </Typography>
              </Stack>

              <Typography fontSize={18} color="gray" gutterBottom>
                CPF: {dadosPaciente.cpf}
              </Typography>
              <Typography fontSize={18} color="gray" gutterBottom>
                CNS: {dadosPaciente.cns}
              </Typography>
              <Typography fontSize={12} color="gray" gutterBottom sx={{ m: 1 }}>
                Usuário cadastrado em{" "}
                {formatDate(detalhesPaciente?.paciente?.dataCadastro)}
                {detalhesPaciente?.cadastradoPor === null ? (
                  ""
                ) : (
                  <span>
                    {" "}
                    por {detalhesPaciente?.cadastradoPor?.nome} <br></br> (
                    {detalhesPaciente?.cadastradoPor?.perfil} -{" "}
                    {detalhesPaciente?.cadastradoPor?.estabelecimentoDeSaude})
                  </span>
                )}
              </Typography>
            </Stack>
          </Box>
        }
      />
    </>
  );
}
